import React from 'react';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import { Trans, useTranslation } from 'react-i18next';
import mapValues from 'lodash/mapValues';
import { ProgressLine } from '@app/core';
import { getLocale } from '@app/i18n';

const useColorStyles = createUseStyles((theme: Theme) =>
  mapValues(theme.colorDefinitions, (color) => ({
    color: color.accessible,
    '& i.main-icon': {
      color: color.accessible,
    },
    '& div.icon-container': {
      backgroundColor: color.muted,
    },
  })),
);

const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    padding: theme.marginBase * 2,
    minWidth: 220,
    borderRadius: theme.borderRadius.std,
    border: 'solid 1px',
    borderColor: theme.colors.grayBorder,
    backgroundColor: theme.colors.white,
  },
  title: {
    ...theme.fonts.label,
    textTransform: 'uppercase',
    marginBottom: theme.marginBase * 2,
    textAlign: 'center',
  },
  value: {
    ...theme.fonts.h4,
    color: 'inherit',
    textAlign: 'center',
  },
}));

interface Props {
  text: string;
  color?: Colors;
  className?: string;
  value?: number;
  unit?: 'Mbps' | 'ms';
}

export const LatencyBox = ({
  text,
  color = 'blue',
  className,
  value,
  unit,
}: Props) => {
  const classes = useStyles();
  const { i18n, t } = useTranslation();
  const colorClasses = useColorStyles();

  const currentValue = value && unit === 'Mbps' ? value / 1_000_000 : value;
  const strValue = !currentValue
    ? '-'
    : Intl.NumberFormat(getLocale(i18n), {
        maximumFractionDigits: 2,
      }).format(currentValue);
  const res = unit ? `${strValue} ${unit}` : strValue;

  return (
    <div
      className={classnames(classes.content, colorClasses[color], className)}
    >
      <h4 className={classes.title}>{t(text)}</h4>
      <div className={classes.value}>{res}</div>
    </div>
  );
};
